<!-- 登录页 -->
<template>
  <div class="webcardbindMain">
    <!-- <div class="webcardloginHead">
      <div class="headleft">&nbsp;&nbsp;新卡绑定</div>
      <div class="headlright" @click="cardBackpage()">返回上一步&nbsp;&nbsp;</div>
    </div> -->
    <div class="webwrapCardBody" style="max-height:400px; overflow-y:auto; ">
      <div class="Hseat"></div>
      <div class="inputForm">
        <div class="telDivCard">
          <i class="iconfont iconiconfontshouji"></i>
          <!-- pswWidth1 -->
          <input class="pswWidth1" type="text" placeholder="请输入卡号" v-model="cardNumber" />
           <i class="iconfont iconscan" style="float: right" @click="s"></i>
        </div>
        <div class="telDivCard tel_passworld">
          <i class="iconfont iconsuo"></i>
          <input :type="eysTrue ? 'password' : 'text' " placeholder="电子码或密码8-12位不区分大小写" v-model="cardPwd" class="pswWidth1">
          <i :class="['iconfont', eysTrue ? 'icon-eyeopen' : 'icon-eyeclose']" style="float: right" @click="() => eysTrue = !eysTrue"></i>
        </div>
        <div class="clearBoth"></div>
        <!-- v-if="codeNum >= 3" -->
        <div class="telDivCard">
          <i class="iconfont iconiconfont5"></i>
          <input class="pswWidth" type="text" placeholder="请输入验证码" v-model="imageCode" />
          <img :src="imgUrl" @click="getCode" />
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtnCard" @click="login">确定</div>
      <div class="agremmentCard">
        <p>温馨提示：如果只有密码，无需填写第一个输入框内容</p>
      </div>
    </div>
 
  </div>
</template>

<script >
import * as api from '@/api'
import { mapMutations } from 'vuex'
import JmmToast from '@/components/JmmToast'
import wx from 'weixin-js-sdk'
let cardNumberRegular = /^\d{11,13}$/
import '@/assets/stylecss/iconfont.css'
export default {
  name: 'login',
  data() {
    return {
      eysTrue: true,     // 密码框 显示小眼睛
      pid: '',      // 参数只获取不做处理,直接返回
      pname: '',    // 参数只获取不做处理,直接返回
      // sign: 'jobpikflkmafhdefpfmlgminkechhphd',
      sign: 'abmgfihjfmpabfmmodepamjlfjgglkppogljplpmkadnndafcaohniimelginhbifjchoofjaklmgepodapffbhnabplkcng',
      cardNumber: '',
      cardPwd: '',
      code: '',
      scanlinks: '',
      businessid: '',
      imgUrl: '',
      imageCode: '',
      sessionKey: '',
      codeNum:0,     //如果大于等于3显示验证码否则不显示  
      channel: '',   // 判断渠道ID 
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.sign = this.$route.query.sign
    this.card_bag = this.$route.query.card_bag
    this.pid = this.$route.query.pid
    this.pname = this.$route.query.name
    this.sessionKey = this.$route.query.sessionKey
    this.scanlinks = this.$route.query.scanlinks
    this.businessid = this.$route.query.businessid
    this.channel = this.$route.query.channel
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
    this.scanlinks ? this.wxLogin() : ''
  },
  components: {
    JmmToast,
  },
  computed: {},
  mounted: function () {
    this.getCode();
    // sessionStorage.setItem('reTest', 'test')
  },
  methods: {
    async getCode() {
      let _this = this
      try {
        let testToken = 'fdimbnemeiellmogjpkdbpadhccfefnd'
        localStorage.setItem('reToken', testToken)
        localStorage.setItem('SESSIONKEY', _this.sessionKey)

        let data = await api.user.getCode(_this.sign, 'img')
        _this.imgUrl = window.URL.createObjectURL(data)
      } catch (err) {
        console.log(err)
      }
    },
    //扫码登录
    async wxLogin() {
      let _this = this
      let testToken = 'fdimbnemeiellmogjpkdbpadhccfefnd'
      try {
        if (_this.scanlinks != undefined) {
          let info = {
            businessid: _this.businessid ? this.businessid : '10002',
            // businessid: _this.businessid ? this.businessid : '10001',
            sign: _this.sign,
            scanLinks: _this.scanlinks,
            isbind: 1,
            card: '',
            pwd: '',
            channel: _this.channel
          }
          localStorage.setItem('reToken', testToken)
          const { code, data, message } = await api.user.cardBindScanLinks(info)
          //  alert(JSON.stringify(message) + '==扫码传参数==' + JSON.stringify(info))
          if (code == '000000') {
              
            var ua = navigator.userAgent.toLowerCase()
            console.log(ua)
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
              console.log(1.5)
              //微信环境
              wx.miniProgram.getEnv(function (res) {
                console.log(2)
                if (res.miniprogram) {
                   wx.miniProgram.redirectTo({
                    url: "/pages/sn-tabbar/sn-tabbar?curPage=2&card_bag=" + _this.card_bag
                  });
                } else {
                  console.log(3)
                  //非小程序环境下逻辑
                  //JmmToast("只支持小程序访问");
                  return false
                }
              })
            } else {
              console.log(3)
              //非小程序环境下逻辑
              //JmmToast("非小程序环境不能跳转");
              return false
            }
          } else {
            JmmToast(message)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 点击登录
    async login() {
      let _this = this
      try {
        //  if(_this.cardNumber.length==0||_this.cardNumber.length==13){
        //    }
        //      else{
        //JmmToast("当前只支持13位卡登陆，部分卡请在看购福利公众号使用！");
        //return;
        //   }

        if (_this.cardPwd == '') {
          JmmToast('请输入正确的密码')
          return
        }
        // if(this.codeNum >= 3){
          if (!_this.imageCode) {
            JmmToast('请输入完整的验证码')
            return
          }
        // }

        let testToken = 'fdimbnemeiellmogjpkdbpadhccfefnd'
        let testBusinessid = '10002'
        //执行登陆接口
        let cinfo = {
          sign:  _this.sign,
          card: _this.cardNumber,
          pwd: _this.cardPwd,
          isbind: 1,
          scanLinks: '',
          businessid: testBusinessid,
          imageCode: _this.imageCode,
          channel: _this.channel,
          // imageCode: this.codeNum <= 3 ? 0 : _this.imageCode,
        }
        localStorage.setItem('reToken', _this.token == undefined ? testToken : _this.token)
        //JmmToast(cinfo);
        const { code, data, message } = await api.user.bindCard(cinfo)
        if (code == '000000') {
          var ua = navigator.userAgent.toLowerCase()
          console.log(ua)
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            console.log(1.5)
            //微信环境
            wx.miniProgram.getEnv(function (res) {
              console.log(2)
              if (res.miniprogram) {
                 wx.miniProgram.redirectTo({
                   url: "/pages/sn-tabbar/sn-tabbar?curPage=2&card_bag=" + _this.card_bag
                });
              } else {
                console.log(3)
                //非小程序环境下逻辑
                JmmToast('只支持小程序访问')
                return false
              }
            })
          } else {
            console.log(3)
            //非小程序环境下逻辑
            //JmmToast("非小程序环境不能跳转");
            return false
          }
        } else {
          // this.codeNum ++;
          // if(this.codeNum >= 3){
          //   this.getCode();
          // }
          JmmToast(message)
        }
      } catch (err) {
        console.log(err)
      }
    },
    s: function () {
      //JmmToast("0");
      let that = this
      var ua = navigator.userAgent.toLowerCase()
      //  JmmToast(ua);

      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // console.log(1.5)
        //微信环境
        // JmmToast("微信环境:1.5" + this.token);
        //var posturl="/pages/pageScanCode/pageScanCode?info=scanlinks&token="+this.token+"&sign="+this.sign;
        //JmmToast(posturl);
        wx.miniProgram.getEnv(function (res) {
          // JmmToast("微信环境:2.0");
          console.log(2)
          if (res.miniprogram) {
            wx.miniProgram.redirectTo({ url: '/pages/index/pageScanCode/pageScanCode?pid=' + that.pid + "&name=" + that.pname +'&channel=' +that.channel })
          } else {
            console.log(3)
            //非小程序环境下逻辑
            JmmToast('只支持小程序访问')
            return false
          }
        })
      } else {
        console.log(3)
        //非小程序环境下逻辑
        //JmmToast("只支持小程序访问");
        return false
      }
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.tel_passworld img{
  width: 15px; 
  vertical-align: middle;
  float: right;
}

.webcardbindMain
  width 100%
  height 100%
  overflow hidden
  background #fff
.webcardbindMain .webcardloginHead
  width 100%
  height 50px
  line-height 50px
  text-align center
.webcardbindMain .webcardloginHead .headleft
  float left
  text-align left
  width 70%
  font-size 30px
  height 50px
.webcardbindMain .webcardloginHead .headright
  float right
  text-align right
  width 30%
  font-size 30px
  height 50px
.webwrapCardBody
  width 100%
  height 100%
.webwrapCardBody .Hseat
  height 60px
.webwrapCardBody .telDivCard
  width calc(100% - 150px)
  margin 15px auto
  height 110px
  border-bottom 1px solid #ddd
  i
    font-style normal
    margin-top 30px
    float left
    vertical-align middle
  input
    height 80px
    font-size 45px
    margin-left 20px
    border none
    vertical-align middle
    line-height: normal; 
  button
    border 2px solid $codeColor
    width 180px
    height 66px
    font-size 28px
    background $codeColor
    color black
    float right
  img
    width 30% !important
    height 45px !important
    display inline-block
    vertical-align middle
  .pswWidth
    font-size 32px
    width 50% !important
    display inline
  .pswWidth1
    font-size 32px
    width 80% !important
    display inline
.loginBtnCard
  width calc(100% - 150px)
  height 90px
  line-height 90px
  margin 0 auto
  background $background
  border-radius 45px
  font-size 34px
  text-align center
  color $color
.agremmentCard
  width calc(100% - 224px)
  margin 32px auto
  font-size 24px
.clearBoth
  clear both
.leftRouter
  float $floLeft
.rightRouter
  float $florRight
.card
  background #fff
  height 100%
input::-webkit-input-placeholder /* WebKit browsers */
  font-size 28px
  line-height normal
input::-moz-input-placeholder /* Mozilla Firefox */
  font-size 28px
  line-height normal
input::-ms-input-placeholder /* Internet Explorer */
  font-size 28px
  line-height normal


  .codeLogin_sao {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.3;
  }
</style>



// WEBPACK FOOTER //
// src/view/zxcardbind/index.vue